import { IMAGES } from '../constants/images';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Hero() {
  return (
    <section className="banner" aria-label="Family Tree Maker Help Center">
      <div className="banner__media">
        <img
          src={IMAGES.community}
          alt="Illustrated family tree with portraits of several generations"
          width={900}
          height={900}
          fetchPriority="high"
        />
      </div>
      <div className="banner__copy">
        <p className="banner__eyebrow">Your Independent FTM Help Line</p>
        <p className="banner__title">Family Tree Maker Support</p>
        <button type="button" className="banner__quote" onClick={openZohoChat}>
          “Stuck With Family Tree Maker? Real People, Real Fixes, Any Hour”
        </button>
        <p className="banner__sub">Tap to Chat or Call</p>
        <a href={SUPPORT_PHONE_TEL} className="banner__phone">
          ☎ {SUPPORT_PHONE_LABEL}
        </a>
      </div>
    </section>
  );
}
